export default {
    environment: process.env.NODE_ENV,
    properties_url: process.env.REACT_APP_PROPERTIES_URL,
    origin_url: process.env.REACT_APP_ORIGIN_URL,
    audit_url: process.env.REACT_APP_AUDIT_URL,
    x_api_key: process.env.REACT_APP_X_API_KEY,
    rp_search_url: process.env.REACT_APP_RP_SEARCH_URL
}
